export enum DogEarType {
  LOCKED = 'locked',
  FOLLOW_GATED = 'follow gated'
}
